module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-11.169594cc.png";